import { useContext, useEffect } from "react";
import { Button, CircularProgress, Typography } from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
type ChangeParamsType = {
  target: { value: any; name: string };
  name: string;
};
import { useForm } from "react-hook-form";
import { ApprovedSearchContext } from "..";
import { useMutation, useQuery } from "react-query";
import { Search } from "@mui/icons-material";
import {
  getInsuranceType,
  getInsuranceByParams,
  getPostOffice,
} from "../../services";
import { findPriorApprovals, getInsuracePlan } from "../../services";
import { FormOnChangeEventType } from "../../../EMR/types";
import usePopup from "../../../hooks/usePopup";
import useAuthentication from "@hooks/useAuthentication";
import { PriorApprovalSearchFormType, defaultFormData } from "../types";
import moment from "moment";
const today = moment(new Date()).format("yyyy-MM-DD");
const fieldsForClear = ["insuranceType", "receiver", "payer", "insurancePlan"];
function SearchArea() {
  const { showSnackbar } = usePopup();
  const { user } = useAuthentication();
  const {
    setPriorApprovalSearchParams,
    priorApprovalSearchParams,
    setSearchResult,
    setDowloadLoading,
  } = useContext(ApprovedSearchContext);
  const { handleSubmit, watch, control, getValues, resetField, reset } =
    useForm<PriorApprovalSearchFormType>({
      defaultValues: defaultFormData,
    });
  const insType = watch("insuranceType");

  const { data: insuranceType, isLoading: insuranceTypeLoading } = useQuery(
    ["insuranceTypesForPriorApproval"],
    getInsuranceType,
    { refetchOnWindowFocus: false },
  );

  const {
    mutate: getReveiverByType,
    data: receiver,
    isLoading: receiverLoadig,
  } = useMutation(getInsuranceByParams);

  const {
    mutate: getPayerByType,
    data: payer,
    isLoading: payerLoadig,
  } = useMutation(getInsuranceByParams);

  const {
    mutate: fetchInsurancePlans,
    data: insurancePlans,
    isLoading: insurancePlansLoading,
  } = useMutation(getInsuracePlan);

  const { data: postOffice, isLoading: postOfficeLoading } = useQuery(
    ["fetchPostOfficeForPriorApproval"],
    getPostOffice,
    {
      refetchOnWindowFocus: false,
    },
  );

  const { mutate: fetchPriorApproval, isLoading: priorApprovlsloading } =
    useMutation(findPriorApprovals, {
      onSuccess: (result) => {
        const items = result.response?.items;
        const messageFromBackend = result.response?.responseMessage;
        console.log(messageFromBackend);
        if (Array.isArray(items) && items.length === 0 && priorApprovalSearchParams.operation == "download") {
          showSnackbar({
            message: messageFromBackend || "No prior approvals found",
            open: true,
            variant: "info",
            duration: 2000,
          });
        } else {
          setSearchResult(result.response);
        }
      },
      onError: (e: any) => {
        console.log();

        showSnackbar({
          message:
            e?.response?.data?.responseMessage || "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 3000,
        });
        if (priorApprovalSearchParams.operation == "download") {
          setPriorApprovalSearchParams((prev) => ({
            ...prev,
            operation: "search",
          }));
        }
      },
    });

  const clearField = (index: number) => {
    for (let i = index; i < fieldsForClear.length; i++) {
      resetField(fieldsForClear[i] as keyof typeof defaultFormData);
    }
  };

  function onSubmit(value: PriorApprovalSearchFormType) {
    localStorage.setItem(
      "priorApprovalSearchParams",
      JSON.stringify({ fromDate: value.fromDate, toDate: value.toDate,postoffice:value.postoffice }),
    );
    setPriorApprovalSearchParams((prev) => ({
      ...prev,
      fromDate: value.fromDate,
      toDate: value.toDate,
      insTypeId: value.insuranceType?.id || null,
      insNameId: value?.receiver?.id || value?.payer?.id || null,
      insGroupId: value?.payer?.id || null,
      insPlanId: value?.insurancePlan?.id || null,
      operation: "search",
      postOfficeId: Number(value?.postoffice?.poId),
      all: value.all,
    }));
  }

  const handleInsurnceTypeChange = (params: ChangeParamsType) => {
    const {
      target: { value },
    } = params;
    clearField(1);
    const allData = watch();
    if (Boolean(value)) {
      if (value.id == 1) {
        getReveiverByType({ typeId: value.id });
      } else {
        getPayerByType({ typeId: value.id });
      }
      setPriorApprovalSearchParams((prev) => ({
        ...prev,
        all: false,
      }));
      reset({
        ...allData,
        all: false,
      });
    } else {
      setPriorApprovalSearchParams((prev) => ({
        ...prev,
        all: true,
      }));
      reset({
        ...allData,
        insuranceType: null,
        receiver: null,
        payer: null,
        insurancePlan: null,
        all: true,
      });
    }
  };

  const handleInsurnceNameChange = (_: ChangeParamsType) => {
    let params: {
      clinicId: number;
      insType: number;
      insName: number;
      insGroup?: number;
    } = {
      clinicId: 0,
      insName: 0,
      insType: 0,
    };
    if (insType?.id == 1) {
      params = {
        insType: Number(getValues("insuranceType")?.id),
        insName: Number(getValues("receiver")?.id),
        insGroup: Number(getValues("payer")?.id),
        clinicId: Number(user?.clinicId),
      };
    } else {
      params = {
        insType: Number(getValues("insuranceType")?.id),
        insName: Number(getValues("payer")?.id),
        clinicId: Number(user?.clinicId),
      };
    }
    fetchInsurancePlans(params);
  };

  const handleReset = () => {
    if (postOffice?.response) {
      reset({
        ...defaultFormData,
        postoffice: postOffice?.response[0],
      });
    }
    setPriorApprovalSearchParams((prev) => ({
      ...prev,
      fromDate: null,
      toDate: null,
      all: true,
      operation: "search",
    }));
  };

  const onChange = (e: FormOnChangeEventType) => {
    const { target } = e;
    const searchData = watch();
    if (target.name == "all") {
      setPriorApprovalSearchParams((prev) => ({
        ...prev,
        all: target.value,
      }));
      if (target.value) {
        reset({
          ...searchData,
          insuranceType: null,
          receiver: null,
          payer: null,
          insurancePlan: null,
        });
      }
    }
    if (target.name == "postoffice") {
      reset({
        ...searchData,
        insuranceType: null,
        receiver: null,
        payer: null,
        insurancePlan: null,
        all: true,
      });
    }
  };

  useEffect(() => {
    const paramsData = JSON.parse(localStorage.getItem("priorApprovalSearchParams") || JSON.stringify({fromDate:moment().format("YYYY-MM-DD"),toDate:moment().format("YYYY-MM-DD")}))
    if (postOffice?.response) {
      reset({
        ...paramsData,
        postoffice:paramsData?.postoffice || postOffice?.response[0],
        all: true,
      });
    }
  }, [postOffice]);

  useEffect(() => {
    setDowloadLoading(priorApprovlsloading);
  }, [priorApprovlsloading]);

  useEffect(() => {
    if (
      (Boolean(priorApprovalSearchParams?.fromDate) &&
        Boolean(priorApprovalSearchParams?.toDate)) ||
      priorApprovalSearchParams.operation == "download"
    ) {
      const postOfficeId = Number(getValues("postoffice")?.poId);
      if (priorApprovalSearchParams.operation == "download" && postOfficeId) {
        fetchPriorApproval({ ...priorApprovalSearchParams, postOfficeId });
      } else {
        fetchPriorApproval(priorApprovalSearchParams);
      }
    }
  }, [priorApprovalSearchParams]);

  return (
    <div>
      <div className="p-2">
        <div className="pb-2 border-b">
          <Typography fontSize={14} fontWeight={"bold"}>
            Approved <Search />
          </Typography>
          {/* <Button onClick={handleClick}>click</Button> */}
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid grid-cols-5 gap-3 pt-4"
        >
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date", inputProps: { max: today } }}
            rules={{ required: "From date required" }}
          />

          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "To date required" }}
          />

          <CustomFormField
            control={control}
            options={insuranceType?.response || []}
            loading={insuranceTypeLoading}
            element="autocomplete"
            name="insuranceType"
            fieldProps={{ label: "Insurance Type" }}
            autocompleteProps={{
              isOptionEqualToValue: (option, value) => option.id == value.id,
              getOptionLabel: (option) => option.name,
            }}
            rules={{
              required: priorApprovalSearchParams.all
                ? false
                : "Insurance Type required",
              onChange: handleInsurnceTypeChange,
            }}
          />
          <div className={insType?.id == 1 ? "" : "hidden"}>
            <CustomFormField
              control={control}
              options={receiver?.response || []}
              loading={receiverLoadig}
              element="autocomplete"
              name="receiver"
              fieldProps={{ label: "Receiver" }}
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              rules={{
                required: insType?.id == 1 ? "Receiver required" : false,
                onChange: () => {
                  clearField(2);
                  getPayerByType({ typeId: 2 });
                },
              }}
            />
          </div>
          <div>
            <CustomFormField
              control={control}
              options={payer?.response || []}
              loading={payerLoadig}
              element="autocomplete"
              name="payer"
              autocompleteProps={{
                isOptionEqualToValue: (option, value) => option.id == value.id,
                getOptionLabel: (option) => option.name,
              }}
              fieldProps={{
                label: insType?.id == 1 ? "Payer" : "Insurance",
              }}
              rules={{
                required: priorApprovalSearchParams.all
                  ? false
                  : insType?.id == 1
                    ? "Payer required"
                    : "Insurance required",
                onChange: handleInsurnceNameChange,
              }}
            />
          </div>
          <CustomFormField
            control={control}
            options={insurancePlans?.response || []}
            loading={insurancePlansLoading}
            element="autocomplete"
            name="insurancePlan"
            fieldProps={{ label: "Insurance Plan" }}
            autocompleteProps={{
              isOptionEqualToValue: (option, value) => option.id == value.id,
              getOptionLabel: (option) => option.name,
            }}
            rules={{
              required: priorApprovalSearchParams.all
                ? false
                : "Insurance Plan required",
            }}
          />
          <CustomFormField
            control={control}
            element="autocomplete"
            name="postoffice"
            fieldProps={{ label: "Post Office" }}
            autocompleteProps={{
              isOptionEqualToValue: (option, value) =>
                option.poId == value.poId,
              getOptionLabel: (option) => option.poName,
            }}
            options={postOffice?.response || []}
            loading={postOfficeLoading}
            rules={{ required: "Post Office required", onChange }}
          />
          <div className="hidden">
            <CustomFormField
              control={control}
              name="all"
              element="checkbox"
              fieldProps={{ label: "All" }}
              rules={{ required: false, onChange }}
            />
          </div>
          <div
            className={
              insType?.id == 1
                ? "col-span-3 flex justify-end gap-2 items-center"
                : "col-span-4 flex justify-end gap-2 items-center"
            }
          >
            <Button
              disabled={priorApprovlsloading}
              endIcon={
                priorApprovlsloading &&
                Boolean(priorApprovalSearchParams.operation == "search") && (
                  <CircularProgress size={18} />
                )
              }
              size="small"
              type="submit"
            >
              search
            </Button>
            <Button
              onClick={handleReset}
              size="small"
              type="reset"
              color="error"
            >
              clear
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SearchArea;
